import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DashboardWorkOrderGraphData } from 'app/_models/dashboard-work-order-graph-data.model';
import { WorkOrderStateService } from 'app/_services/work-order-state.service';
import { WorkOrderModalComponent } from '../../modals/work-order-modal/work-order-modal.component';

@Component({
  selector: 'work-order-bar-graph',
  templateUrl: './work-order-bar-graph.component.html'
})
export class WorkOrderBarGraphComponent implements OnInit, OnChanges {
  @Input() workOrders: DashboardWorkOrderGraphData[];
  public max: number = 100000; // large initial value to aid animation

  constructor(
    private workOrderStateService: WorkOrderStateService,
    private modalService: NgbModal,
  ) { }

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['workOrders'].previousValue !== changes['workOrders'].currentValue) {
      this.workOrders.forEach(workOrderCategory => {
        workOrderCategory.color = this.workOrderStateService.workOrderStateToBadgeClass(workOrderCategory.key);
      });

      const values = this.workOrders.map(obj => obj.value);

      // small delay allows bar to be shown initially, and animate to full size
      setTimeout(() => {
        this.max = Math.max(...values);
      }, 1);
    }
  }

  public onRowClick(category) {
    const modalRef = this.modalService.open(WorkOrderModalComponent, { centered: true, size: 'lg' });
    modalRef.componentInstance.graphData = category;
  }
}

